import { Card, Result } from 'antd';
import { useListTeamClients } from 'client/modules/external-api/hooks/queries/external-api';
import { AntPageLayoutWithHeader } from 'client/modules/permissions/components/AntPageLayoutWithHeader';
import { useParams } from 'react-router-dom';
import { DataFeedConfigurationFormTabs } from '../components/DataFeedFormTabs';
import { pageTitle } from './TeamDataFeedPage';

export const CreateDatafeed = () => {
  const { idTeam } = useParams<{ idTeam: string }>();
  const { data: client, isLoading } = useListTeamClients(Number(idTeam));

  if (!idTeam || Number.isNaN(Number(idTeam))) {
    return <Result status="404" title="Team not found" />;
  }

  const teamName =
    client && client.clients.length > 0 ? client.clients[0].team_name : '';
  return (
    <AntPageLayoutWithHeader title={pageTitle(client, isLoading)}>
      <Card className="w-full" title="Create new data feed">
        <DataFeedConfigurationFormTabs teamName={teamName} idTeam={idTeam} />
      </Card>
    </AntPageLayoutWithHeader>
  );
};
